export default __webpack_public_path__ + "static/media/aiman2.47667df2.png";